const ENV_FULL_URL = window.REACT_APP_API_SITE;
let environment = window.REACT_APP_ENV;

if (environment === 'prod') environment = '';
export const env = environment;

export const baseApiManagerUrlWithoutPrePrefix = `https://mobile${env}.swissmedical.com.ar/api-smg`;
export const baseApiManagerUrl = `https://mobile${env}.swissmedical.com.ar/pre/api-smg`;
export const baseApiManagerUrlCL = `https://mobile${env}.swissmedical.com.ar/cl/api-smg`;

// words to replace in the url
const v0 = 'v0';
const V0 = 'V0';
const v1 = 'v1';
const V1 = 'V1';
const v1_1 = 'v1.1';
const V2 = 'V2';
const v2_2 = 'V2.2';
const v1_0 = 'v1.0';
const V0_1 = 'V0.1';
const V1_0 = 'V1.0';
const V1_1 = 'V1.1';
const V1_2 = 'V1.2';
const PRESTADORES = 'prestadores';
const TRAMITES = 'tramites';
const CONECTIVIDAD = 'conectividad';
const EJECUCIONES = 'ejecuciones';
const AUTORIZACIONES = 'autorizaciones';
const PAGOS_FACTURAS = 'pagos-facturas';
const EXPE = 'expe';
export const urlProvidersBase = `${baseApiManagerUrl}/${V1_0}/${PRESTADORES}`;
export const urlProvidersBaseV1_1 = `${baseApiManagerUrl}/${V1_1}/${PRESTADORES}`;
export const urlProvidersV2 = `${baseApiManagerUrl}/${V1}/${PRESTADORES}`;

// Users
export const urlLoginUsers = `${baseApiManagerUrl}/${v0}/auth-login`;
export const urlRenewToken = `${baseApiManagerUrl}/${v0}/auth-refresh`;
export const urlUserConfig = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/user-config`;
export const urlAllUserPermissions = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/all-permissions`;
export const urlRegisterUsers = `${baseApiManagerUrl}/${V1}/${PRESTADORES}/registracion/prestador`;
export const urlRegisterProviderValidate = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/registracion/verificar`;
export const urlforgotPasswordValidateProvider = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/olvido/validar_datos`;
export const urlforgotPasswordValidateToken = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/usuarios/validar_token`;
export const urlforgotPasswordSendPinMail = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/usuarios/enviar_token`;
export const urlforgotPasswordUpdatePassword = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/olvido/update_password`;
export const urlRegisterSurveyResponse = `${baseApiManagerUrl}/${V1}/${PRESTADORES}/encuesta`;

// CRUD users
export const urlPostRegisterUserPhp = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/registracion/usuario`;
export const urlDeleteRegisterUserPhp = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/usuarios/eliminar_usuario/`;
export const urlUpdateRegisterUserPhp = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/permisos/usuario`;
export const urlUpdatePersonalDataPhp = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/actualizar/datos`;

export const urlGetUsersPhp = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/usuarios/obtener_listado`;
export const urlGetUserById = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/usuarios/solicitar_datos_prestador/`;
export const urlGetSectorRole = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/tipoMail/`;

// Branches.
export const urlBranches = `${ENV_FULL_URL}/smgnewsite/commons/backend/legacy_prestadores/sucursales/lista_sucursales_solr.php?`;

// InfoSwiss
export const urlInfoSwiss = `https://comunicaciones.swissmedical.com.ar/ecco/?rest_route=/smg_services/get_entries`;

// Validar afiliado
export const urlValidarAfiliadoPost = `${baseApiManagerUrl}/${V1}/prestadores/:code/affiliate/data`;
export const urlValidarAfiliadoV1 = `${baseApiManagerUrl}/${V1}/afiliados`;

export const urlValidarAfiliado1 = `https://mobile${env}.swissmedical.com.ar/api-smg/${v1}/afiliados`;
export const urlValidarCredencialAfiliado = `${baseApiManagerUrl}/${V1}/prestadores/valida/credencial`;

// Conectividad
export const urlPrestacionesExceptuadas = `${baseApiManagerUrl}/${V1_0}/${CONECTIVIDAD}/consulta-prestaciones-exceptuadas`;
export const urlSituacionTerapeutica = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/situacionesTerapeuticas/requiereToken`;
export const urlDiagnosticos = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/diagnosticos`;
export const urlBenefits = `${baseApiManagerUrl}/${V1_0}/prestaciones`;
export const urlListPrestacion = `${baseApiManagerUrl}/${V1}/prestaciones-convenio`;
export const urlIngresaPrestacion = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/ingresa-prestacion`;
export const urlIngresaPrestacionClon = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}`;
export const urlAnulaPrestacion = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/anula-prestacion`;
export const urlElegibilidad = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/elegibilidad`;
export const urlIngresaDiagnostico = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/ingresa-diagnostico`;
export const urlAnulaDiagnostico = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/anula-diagnostico`;
export const urlReimpresionTicket = `${baseApiManagerUrl}/${v1_0}/${CONECTIVIDAD}/reimpresionTicket`;
export const urlDescuento = `${baseApiManagerUrl}/${v0}/afiliados/prepaga`;
export const urlPlan = `${baseApiManagerUrl}/${v0}/cobertura/plan`;
export const urlCredencialesDigitales = `${baseApiManagerUrl}/${V1}/prestadores/credenciales/digitales`;
export const urlVerificarToken = `${baseApiManagerUrl}/${V1}/${PRESTADORES}/verificatoken`;
export const urlPrestadoresV2 = `${baseApiManagerUrl}/${V2}/${PRESTADORES}`;
export const urlPrestadoresV1 = `${baseApiManagerUrl}/${V1}/${PRESTADORES}`;
export const urlBuscarTramitesPorFecha = `${baseApiManagerUrl}/${V1_0}/smmp-consumos/transacciones/reportes/transaccionesPorPrestador`;
export const urlFetchReportesByDate = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/srv-transac-remotas`;
export const urlFetchReportesByDateClon = `${baseApiManagerUrl}/${v1}/${EJECUCIONES}/srv-transac-remotas-clone`;
export const urlFetchReportesLiquidaciones = `${baseApiManagerUrl}/${V2}/${EJECUCIONES}/transac-remotas-web`;

/* --- tramites de autorizaciones --- */
// obtener reporte por fecha
export const urlTramitesDeAutorizacionesConsultasPorFecha = `${baseApiManagerUrl}/${V1_0}/${PRESTADORES}/reportes/${AUTORIZACIONES}-por-prestador`;
// reporte pdf tabla
export const urlTramitesDeAutorizacionesDescargarPdfTabla = `${baseApiManagerUrl}/${V1}/prestadores/:code/${AUTORIZACIONES}/pdf`;

// validar afiliado
export const urlTramitesDeAutorizacionesValidarAfiliado = `${baseApiManagerUrl}/${V1_0}/afiliados?contrato=`;

// traslados
export const urlTramitesDeAutorizacionesTrasladosProgramados = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/${TRAMITES}/traslado-programado-cimg`;

// prestaciones
export const urlTramitesDeAutorizacionesPrestaciones = `${baseApiManagerUrl}/${v1_1}/prestaciones?tipo=medicas&activa=true&codigo=`;

// validar cobertura
export const urlTramitesDeAutorizacionesValidarCobertura = `${baseApiManagerUrl}/${V1_0}/${EJECUCIONES}/rem-valida-of-cobert-web`;

// autorizacciones con materiales
export const urlTramitesDeAutorizacionesConMateriales = `${baseApiManagerUrl}/${v2_2}/web-${PRESTADORES}/${TRAMITES}/autorizacion-con-materiales`;
export const urlTramitesDeAutorizacionesMedicacionUnica = `${baseApiManagerUrl}/${V1_2}/web-${PRESTADORES}/${TRAMITES}/autorizacion-medicacion-unica`;

// autorizacciones sin materiales
export const urlTramitesDeAutorizacionesSinMateriales = `${baseApiManagerUrl}/${v2_2}/web-${PRESTADORES}/${TRAMITES}/autorizacion`;

// GIA
export const urlTramitesDeAutorizacionesGIA = `${baseApiManagerUrl}/${V1}/authorizations/gia`;
export const urlProcessDefinitionId = `${baseApiManagerUrl}/${V1}/sgi/getProcessDefinitionId`;

// es autorizable?
export const urlTramitesDeAutorizacionesEsAutorizable = `${baseApiManagerUrl}/${V1}/${CONECTIVIDAD}-${PRESTADORES}/esautorizable`;

// pdf odontodologia
export const urlTramitesDeAutorizacionesPdfOdontodologia = `${baseApiManagerUrl}/${V1_0}/${AUTORIZACIONES}-odonto/pdf`;

// diagnostico por descripcion
export const urlTramitesDeAutorizacionesDiagnosticoPorDescripcion = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/diagnosticos`;

// autorizacion inmediata
export const urlTramitesDeAutorizacionesInmediata = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/${TRAMITES}/autorizacion-inmediata`;

// autorizaciones odontodologia
export const urlTramitesDeAutorizacionesOdontodologia = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/${TRAMITES}/autorizacion-odontologica`;

// tramites sin autorizacion
export const urlTramitesDeAutorizacionesSinAutorizacion = `${baseApiManagerUrl}/${v1_1}/web-${PRESTADORES}/${TRAMITES}/tramite-sin-autorizacion`;

// tramites solicitud web
export const urlTramitesDeAutorizacionesSolicitudWeb = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/${TRAMITES}/solicitud-web`;

// pertenece a un circulo
export const urlTramitesDeAutorizacionesIsCircle = `${baseApiManagerUrl}/alta-${TRAMITES}-${AUTORIZACIONES}/prestador-pertenece-a-un-circulo`;

// obtener terminales
export const urlTramitesDeAutorizacionesObtenerTerminales = `${baseApiManagerUrl}/alta-${TRAMITES}-${AUTORIZACIONES}/obtener-terminales`;

// diagnostico por codigo
export const urlTramitesDeAutorizacionesDiagnosticoPorCodigo = `${baseApiManagerUrl}/alta-${TRAMITES}-${AUTORIZACIONES}/diagnostico-por-codigo`;

// guardar conectividad
export const urlTramitesDeAutorizacionesGuardarConectividad = `${baseApiManagerUrl}/alta-${TRAMITES}-${AUTORIZACIONES}/guardar-${CONECTIVIDAD}`;

// alta tramites salud mental
export const urlTramitesDeAutorizacionesSaludMental = `${baseApiManagerUrl}/alta-${TRAMITES}-${AUTORIZACIONES}/cuidados-salud-mental-discapacidad`;

// adjuntar comprobante
export const urlTramitesDeAutorizacionesAdjuntarComprobante = `${baseApiManagerUrl}/${V1_0}/web-${PRESTADORES}/${TRAMITES}/gestion-caratula-expediente-liquidaciones-cimg`;

// Receta Digital
export const urlRecetasDigitales = `${baseApiManagerUrl}/${V1}/recetas`;

// CONSULTA LIQUIDACIÓN
export const urlTramitesDeAutorizacionesExpeXprestadLiqdetMon = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-xprestad-liq-det-mon-web`;
export const urlTramitesDeAutorizacionesPrestadoresV1 = `${baseApiManagerUrl}/${V1}/${PRESTADORES}/`;
export const urlGetAcreedorCode = `${baseApiManagerUrl}/${V1}/proveedores/validar/`;

// en comun
export const urlTramitesDeAutorizacionesExpeLiquidacionCompro = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-liqui-compro`;
export const urlTramitesDeAutorizacionesExpeDetalles = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-detalle`;

// odontodologia
export const urlTramitesDeAutorizacionesExpeOdoResumenDebitos = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-odon-resumen-debitos-web`;
export const urlTramitesDeAutorizacionesExpeOdoResumen = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-odon-resumen-web`;

// Totales
export const urlTramitesDeAutorizacionesExpeOdoTotales = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-odon-totales`;
export const urlTramitesDeAutorizacionesExpeTotalDebitos = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-total-debitos`;
export const urlTramitesDeAutorizacionesExpeXPrestadDet = `${baseApiManagerUrl}/${V1}/${EJECUCIONES}/${EXPE}-liqui-x-prestad-det`;

// PDF's
export const urlTramitesDeAutorizacionesExpeOrdenDetconWeb = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-orde-detcon-web`;
export const urlTramitesDeAutorizacionesExpeInternacionesDet = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-internaciones-det`;
export const urlTramitesDeAutorizacionesExpeOrdeDetcir = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-orde-detcir-web`;
export const urlTramitesDeAutorizacionesExpeSubTotales = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-subtotales`;
export const urlTramitesDeAutorizacionesExpeComprobantes = `${baseApiManagerUrl}/${V1}/${EJECUCIONES}/${EXPE}-comprobantes`;

// expe errores ---> replaced by expe debitos ambu -> 24/10/2024 rollback requested. Cause: Missing fields in new response. I renamed the variable  to avoid conflicts
export const urlExpeDebitoAmbu = `${baseApiManagerUrl}/${v1_0}/${EJECUCIONES}/${EXPE}-errores`;

// expe debitos ambu
//export const urlExpeDebitoAmbu = `${baseApiManagerUrl}/${V1}/${EJECUCIONES}/${EXPE}_debitos_ambu`;

// orden copago
export const urlTramitesDeAutorizacionesExpeOrdenCopago = `${baseApiManagerUrl}/${V1}/${EJECUCIONES}/${EXPE}-orde-copago-des`;

// consultas de pagos y facturas
export const urlConsultaPagosYFacturasProveedores = `${baseApiManagerUrl}/${V1}/proveedores`;
export const urlConsultaPagosYFacturasProveedoresV0 = `${baseApiManagerUrl}/${V0}/proveedores`;
export const urlConsultaPagosYFacturasEmpresas = `${baseApiManagerUrl}/V1/prestadores/:code/pagos-facturas/empresas`;
export const urlConsultaPagosYFacturasMotivos = `${baseApiManagerUrl}/${V0}/${PAGOS_FACTURAS}/motivos`;
export const urlConsultaPagosYFacturasEstados = `${baseApiManagerUrl}/${V0}/${PAGOS_FACTURAS}/estados`;
export const urlConsultaPagosYFacturasLlamado = `${baseApiManagerUrl}/${V0}/${PAGOS_FACTURAS}/llamado`;
export const urlConsultaPagosYFacturasLlamados = `${baseApiManagerUrl}/${V1}/${PAGOS_FACTURAS}/llamados`;
export const urlPDFConsultaPagosYFacturas = `${baseApiManagerUrl}/${V1}/proveedores/pdf`;
export const urlConsultaPagosYFacturasArchivosAdjuntos = `${baseApiManagerUrl}/${V0}/archivos`;
export const urlConsultaPagos = `${baseApiManagerUrl}/${V1}/prestadores/:code/cuit/:cuit/pagos`;

// formulario contacto
export const UrlContactForm = `${baseApiManagerUrl}/${v0}/${PRESTADORES}/formulario-contacto`;

// terminos y condiciones
export const urlTerminosYCondiciones = `${baseApiManagerUrl}/${v1_0}/terminos`;
export const urlTerminosYCondicionesCheckUpdate = `${baseApiManagerUrl}/${v1_0}/usuarios`;

// CAP WEB - ADP

// `/V1/prestadores/adp/provincias-matriculas`
export const urlAdpProvinciasMatriculas = `/${V1}/${PRESTADORES}/adp/provincias-matriculas`;
// /V1/webprestadores/proxy/merlin/gis/paises/01/provincias
export const urlAdpProvinciasArgentinas = `/${V1}/webprestadores/proxy/merlin/gis/paises/01/provincias`;
// /v1/prestadores/adp/correos
export const urlAdpCorreos = `/${v1}/${PRESTADORES}/adp/correos`;
// /v1/prestadores/adp/matriculas-provinciales
export const urlAdpMatriculasProvinciales = `/${v1}/${PRESTADORES}/adp/matriculas-provinciales`;
// /v1/prestadores/adp/idiomas
export const urlAdpIdiomas = `/${v1}/${PRESTADORES}/adp/idiomas`;
// `/v1/prestadores/cap/alta-tramite`
export const urlAdpCapAltaTramite = `/${v1}/${PRESTADORES}/cap/alta-tramite`;
// `/V1/archivos/rudi/guardar`
export const urlAdpRudiGuardar = `/${V1}/archivos/rudi/guardar`;
// /v0/cuenta/validar/telefono
export const urlAdpValidarTelefono = `/${v0}/cuenta/validar/telefono`;
// `/v1/prestadores/adp/tipo-documentacion`
export const urlAdpTipoDocumentacion = `/${v1}/${PRESTADORES}/adp/tipo-documentacion`;
// /V1/prestadores/adp/lugaresAtencion
export const urlAdpLugaresAtencion = `/${V1}/prestadores/adp/lugaresAtencion`;

/* --- DOC 24 --- */

export const urlCreateSessionDOC24NoProd = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/doc24/sesion-profesional`;
export const urlCreateSessionDOC24Prod = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/doc24/sesion-profesional-prod`;
// export const urlErrorByDoc24 = 'https://mobileqa.swissmedical.com.ar/api-smg/V1/api/terin/SMP_MOBILE_PRESTADOR/emails/'
export const urlErrorByDoc24 = `${baseApiManagerUrlWithoutPrePrefix}/${V1}/api/terin/SMP_MOBILE_PRESTADOR/emails/`;

//Consultorios
export const urlAlquilerMarca = `${baseApiManagerUrl}/${v1}/${PRESTADORES}/sap`;
export const urlCL = `${baseApiManagerUrlCL}/${v1}/${PRESTADORES}/sap`;

export const urlGetPresmedByContract = `${baseApiManagerUrl}/${V1}/converter/contract/presmed?afilmedContract=`;

//Surveys
export const presmedAttentionPlaces = `${baseApiManagerUrl}/${V1}/bot/smmp/solr/cartilla/prestadores/`;
export const presmedSolrAttentionPlaces = `${baseApiManagerUrl}/${V1}/prestadores/solr-query`;

export const urlConvenioPDF = `${baseApiManagerUrl}/V1/prestadores/:code/convenio/pdf`;
export const urlCodeConvenioEnable = `${baseApiManagerUrl}/V1/prestadores/:code/convenio/enable`;
export const urlChannelCommunicationEnable = `${baseApiManagerUrl}/V1/prestadores/:code/channel/enable`;

// cap
export const urlUsuariosByCodeCap = `${baseApiManagerUrl}/V1/prestadores/:code/cap/usuarios`;

export const urlDetailOperation = `${baseApiManagerUrl}/V1/prestadores/:code/sociedad/:sociedad/ejercicio/:ejercicio/operacion/:operacion`;

export const urlReadInvoice = `${baseApiManagerUrl}/V1/prestadores/:code/invoices/read`;
